/**
 * 任务历史记录请求参数
 */
export interface TaskHistoryRequest {
    /**
     * 任务 ID
     */
    task_id: string;
}

/**
 * 步骤内容（动态类型）
 */
export type StepContent = Record<string, any>;

/**
 * 任务步骤
 */
export interface TaskStep {
    /**
     * 步骤类型
     */
    step_type: string;
    /**
     * 步骤名称
     */
    step_name: string;
    /**
     * 步骤内容
     */
    content: StepContent;
    /**
     * 方向
     */
    direction: 'input' | 'output';
    /**
     * 是否隐藏
     */
    hide: boolean;
    /**
     * 创建时间
     */
    created_at: number;
    /**
     * 更新时间
     */
    updated_at: number;
}

/**
 * 任务历史记录响应
 */
export interface TaskHistoryResponse {
    /**
     * 请求状态
     */
    status: boolean;
    /**
     * 错误代码
     */
    error_code: number;
    /**
     * 错误消息
     */
    error_msg?: string;
    /**
     * 响应数据
     */
    data?: {
        /**
         * 任务 ID
         */
        task_id: string;
        /**
         * 任务类型
         */
        task_type: string;
        /**
         * 步骤列表
         */
        steps: TaskStep[];
    };
}

export const TaskHistoryApi = Symbol('TaskHistoryApi');

/**
 * 任务历史记录 API
 */
export interface TaskHistoryApi {
    /**
     * 获取任务历史记录
     */
    getTaskHistory(request: TaskHistoryRequest): Promise<TaskHistoryResponse>;
}
